import { FC } from 'react';
import { useEffect, useState } from 'react';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfImg from 'elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3');
    const { pageStatus } = useDP3Store();
    const [isPC, setIsPC] = useState(true);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726666868281/5.jpg',
            h5List: [
                'https://websiteoss.ecoflow.com/upload/image/1727579091489/au-sc4.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1726716762657/1-2-1-tuya.jpg',
            ],
            subtitle: 'Ensure essential appliances keep working',
            desc: 'A single DELTA Pro 3 unit has a 4kWh battery capacity, easily meeting the electricity needs of a household, and providing peace of mind even in emergencies. Additionally, the capacity can be expanded to 12kWh*, allowing you to use the stored power in the DELTA Pro 3** even during several hours of a power outage.',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1727420240815/dp3k.jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718799251379/a1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1727577989055/dp3sc.jpg',
            ],
            subtitle: '4000W High Output',
            desc: "Multiple high-power household appliances can be used simultaneously. EcoFlow's unique X-Fusion technology allows the DELTA Pro 3 to output 4000W, even when the input is AC230V 2900W. The more stable pure sine wave output ensures an enjoyable experience when using household appliances.",
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718789177451/a2.jpg',
            // h5: 'https://websiteoss.ecoflow.com/upload/image/1727578469015/au-sc2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718768989165/d1.jpg',
            subtitle: 'A comprehensive 10 ms UPS',
            desc: 'Ensures swift 10 ms switch-overs, protecting your NAS systems, servers, and entertainment devices from power disruptions, keeping your technology safe and continuously powered.',
        },
    ];

    if (pageStatus !== IPageStatus.statusA)
        return (
            <div className={`${css.thecomp}`}>
                <p className="title swiper">Keep Your Home Running Smoothly</p>
                <div className="fix-swiper">
                    <EfSwiperLevel2 list={list} hasLevel2 />
                </div>
            </div>
        );

    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-D'} data-section-title={'Keep Your Home Running Smoothly'}>
            <p className="title">Keep Your Home Running Smoothly</p>
            {isPC ? (
                <div className="box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726666868281/5.jpg" />
                    <div className="info">
                        <div className="l">A single source to power almost all of your essential home appliances.</div>
                        <div className="r">
                            <p className="desc">
                                Power multiple high-demand appliances, like 3 ton* central AC to 1 HP water pump - with its robust 4000W and 230V output. Ensure
                                your home’s electricity remains stable even during power outages, all reliably powered by EcoFlow.
                            </p>
                            <p className="tip">*Tested under controlled laboratory conditions with central AC soft starter.</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="box">
                    <Swiper
                        className="swiper-box"
                        modules={[Pagination, Autoplay]}
                        spaceBetween={0}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        loop={true}
                        pagination={{ clickable: true }}
                        // autoplay={{
                        //     delay: 4250,
                        //     disableOnInteraction: false,
                        // }}
                    >
                        <SwiperSlide className={`swiper-item`}>
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726716763132/1-2-tuya.jpg" />
                        </SwiperSlide>
                        <SwiperSlide className={`swiper-item`}>
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726716762657/1-2-1-tuya.jpg" />
                        </SwiperSlide>
                    </Swiper>
                    <div className="info">
                        <p className="l">A single source to power almost all of your essential home appliances.</p>
                        <div className="r">
                            <p className="desc">
                                Power multiple high-demand appliances, like 3 ton* central AC to 1 HP water pump - with its robust 4000W and 230V output. Ensure
                                your home’s electricity remains stable even during power outages, all reliably powered by EcoFlow.
                            </p>
                            <p className="tip">*Tested under controlled laboratory conditions with central AC soft starter.</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TheComp;
